const getFieldValidationStatus = ({ errorMessage, shouldDisableValidation, value, }) => {
    if (errorMessage !== undefined) {
        return 'invalid';
    }
    if (shouldDisableValidation || !value) {
        return 'noValidation';
    }
    return 'valid';
};
export default getFieldValidationStatus;
//# sourceMappingURL=getFieldValidationStatus.js.map